// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbu_a bic_i bic_j","ColorVariants__color":"bbu_b bic_rp","ColorVariants__more":"bbu_c bic_vv"};